import { ApiGetNotificationsResponse } from './../api/services/isloggedinwebsocket/isloggedinwebsocket.types'
export const adaptNotificationData = (
  notificationData: ApiGetNotificationsResponse
) => {
  return {
    ...notificationData,
    notificationDataList: notificationData.notificationDataList
  }
}
